import * as React from "react";
import { inject, observer } from "mobx-react";
import { autorun } from "mobx";

import { WithSnackbarProps, withSnackbar } from "notistack";
import FSNotifierStore from "./store";

import { INotifier } from "../../entryes/panel/Filestorage/types";
import { SvgIcon } from "../SvgIcon";

interface IProps extends WithSnackbarProps {
  fsNotifierStore?: FSNotifierStore;
}

@inject("fsNotifierStore")
@observer
class Notifier extends React.Component<IProps> {
  displayed: Array<number> = [];

  storeDisplayed = (id: number) => {
    this.displayed = [...this.displayed, id];
  };

  componentDidMount() {
    autorun(() => {
      const { noteList = [] } = this.props.fsNotifierStore;
      noteList.forEach((note: INotifier) => {
        if (this.displayed.includes(note.key)) return;
        this.props.enqueueSnackbar(note.message, {
          ...note.options,
          action: (key) => (
            <div style={{cursor: 'pointer'}} onClick={() => this.props.closeSnackbar(key)}><SvgIcon type={`search-clear`} /></div>
          )
        });
        this.storeDisplayed(note.key);
        this.props.fsNotifierStore.removeSnackbar(note);
      });
    });
  }

  render() {
    return <div></div>;
  }
}

export default withSnackbar(Notifier);
